<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-08 18:18:44
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-21 11:12:09
 * @FilePath: /chaoyongtuan/src/views/teamManage/performanceManage/components/overview/overview.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="overview">
		<div class="title-wrapper">
			<div class="left">
				<span class="title">业绩概览</span>
				<span class="tip ml-8">*数据更新时间为T+1，仅展示达人商务业绩</span>
			</div>
		</div>
		<div class="el-carousel-wrapper">
			<div class="left pointer" @click="prev" :class="isDisabled('prev') ? 'disabled' : ''">
				<i class="el-icon-back"></i>
			</div>
			<div class="right pointer" @click="next" :class="isDisabled('next') ? 'disabled' : ''">
				<i class="el-icon-right"></i>
			</div>
			<el-carousel
				@change="change"
				:initial-index="initialIndex"
				indicator-position="none"
				arrow="never"
				:autoplay="false"
				ref="carousel"
				height="180px"
				direction="horizontal"
				:loop="false"
			>
				<el-carousel-item v-for="(group, index) in list" :key="index">
					<div class="item-wrapper">
						<infoItem :item="item" v-for="item in group" :key="item.key"></infoItem>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>
	</div>
</template>
<script>
import infoItem from './infoItem.vue';
export default {
	props: {
		dataList: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		infoItem,
	},
	data() {
		return {
			list: [],
			initialIndex: 0,
			index: 0,
		};
	},
	computed: {
		isDisabled() {
			return type => {
				if (type === 'next' && this.index === this.list.length - 1) {
					return true;
				} else if (type === 'prev' && this.index === 0) {
					return true;
				}
				return false;
			};
		},
	},
	watch: {
		dataList: {
			handler(val) {
				if (val.length) {
					this.list = this.groupArray(val);
				}
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		groupArray(list) {
			var result = [];
			for (var i = 0, len = list.length; i < len; i += 10) {
				result.push(list.slice(i, i + 10));
			}
			return result;
		},
		next() {
			this.$refs.carousel.next();
		},
		prev() {
			this.$refs.carousel.prev();
		},
		change(i) {
			this.index = i;
		},
	},
};
</script>
<style lang="less" scoped>
.overview {
	.title-wrapper {
		display: flex;
		justify-content: space-between;
		.title {
			font-family: PingFang SC;
			font-size: 18px;
			font-weight: 700;
			line-height: 24px;
			color: @color-text-primary;
		}

		.tip {
			font-family: PingFang SC;
			font-size: 12px;
			line-height: 20px;
			color: @color-text-secondary;
		}
	}
	.el-carousel-wrapper {
		position: relative;
		padding: 16px 50px;
		.left,
		.right {
			width: 32px;
			height: 32px;
			display: flex;
			align-items: center;
			justify-content: center;
			&:hover {
				color: @color-primary;
				background: #f0f5ff;
			}
			&.disabled {
				color: @color-gy6;
				background: @color-gy2;
				&:hover {
					color: @color-gy6;
				}
				.el-icon-back {
					color: @color-gy6;
				}
			}
		}
		.left {
			position: absolute;
			z-index: 11;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			background: @color-gy2;
			border-radius: 4px;
		}
		.right {
			position: absolute;
			z-index: 11;
			right: 0;
			top: 50%;
			transform: translateY(-50%);
			background: @color-gy2;
			border-radius: 4px;
		}
	}
	.item-wrapper {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		gap: 12px;
		height: 180px;
		align-content: flex-start;
	}
}
</style>
